import { useAtomValue } from 'jotai';
import { hasActiveAdminAtom } from '../../state/atoms';
import {
  INVITE_USER_ROLE_OPTIONS,
  OptionV2,
} from '@spins-gcp/shared-components-react';
import { EmailVerificationPurpose, UserSystemStatus } from '../../queries';
import { NewUserFormInput } from '../../interfaces/interfaces';
import { useVerifiedEmailToken } from '../../hooks/use-verified-email-token';
import { RegisterLoading } from '../register-loading/register-loading';
import { InvalidVerificationLink } from '../invalid-verification-link/invalid-verification-link';
import { NewUserWithAdmin } from './new-user-with-admin';
import { NewUserWithoutAdmin } from './new-user-without-admin';

const roleOptions: OptionV2<string>[] = INVITE_USER_ROLE_OPTIONS.map(
  (role) => ({ label: role, value: role })
);

const NEW_USER_STATUSES: ReadonlyArray<UserSystemStatus> = [
  UserSystemStatus.UserNotInAuth,
  UserSystemStatus.UserNotInSf,
];

export const NewUser = () => {
  const verification = useVerifiedEmailToken(
    EmailVerificationPurpose.NewUser,
    NEW_USER_STATUSES
  );
  const hasActiveAdmin = useAtomValue(hasActiveAdminAtom);

  if (verification.status === 'invalid') {
    return <InvalidVerificationLink />;
  }
  if (verification.status === 'pending') {
    return <RegisterLoading />;
  }

  const initialValues: NewUserFormInput = {
    firstName: '',
    lastName: '',
    workEmail: verification.email,
    role: '',
  };
  const NewUserForm = hasActiveAdmin ? NewUserWithAdmin : NewUserWithoutAdmin;

  return (
    <NewUserForm initialValues={initialValues} roleOptions={roleOptions} />
  );
};

export default NewUser;
